import { useContext } from 'react'
import { Link } from 'react-router'
import { Typography } from '@mui/material'
import { GridCellParams } from '@mui/x-data-grid-pro'

import { AppContext } from '../../../../providers/app-provider'

const AlertTablePanelPerson = (cellParams: GridCellParams<DeviceAlertPanelTableRow, DeviceAlertPanelTableRow['person']>) => {
  const { tenantId } = useContext(AppContext)
  const cellValue = cellParams.value

  if (!cellValue)
    return (
      <Typography
        variant="body1"
        sx={{
          color: 'text.disabled',
        }}
      >
        N/A
      </Typography>
    )

  const usersName = [cellValue.firstName, cellValue.lastName].filter((x) => x).join(' ')

  return (
    <div>
      <Link to={`/tenant/${tenantId}/people/${cellValue.id}`} className="fs-exclude">
        {usersName}
      </Link>
    </div>
  )
}

export default AlertTablePanelPerson
